import type React from "react";

import { translate } from "app/filters/i18nFilter";
import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import { COMPANY_ANALYSIS_DIGITAL_ASSETS } from "app/pages/sales-intelligence/constants/routes";
import Card from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/Card";
import CardFooter from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardFooter/CardFooter";
import CardHeader from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardHeader/CardHeader";
import { DigitalAssetsCard } from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/DigitalAssetsCard/DigitalAssetsCard";
import { EmptyState } from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/DigitalAssetsCard/EmptyState";

const DigitalAssetsCardWithErrorBoundary: React.FC = () => {
    return (
        <ErrorBoundaryWithLogging
            fallback={
                <Card
                    dataAutomation="digital-assets-card"
                    header={
                        <CardHeader
                            title={translate("si.company-analysis.digital-assets-card.title")}
                            infoTooltip={translate("si.company-analysis.digital-assets.card.header.tooltip")}
                        />
                    }
                    renderContent={() => <EmptyState />}
                    footer={<CardFooter stateId={COMPANY_ANALYSIS_DIGITAL_ASSETS} />}
                    width="50%"
                />
            }
        >
            <DigitalAssetsCard />
        </ErrorBoundaryWithLogging>
    );
};

export default DigitalAssetsCardWithErrorBoundary;
